import { render, staticRenderFns } from "./CopyPaste.vue?vue&type=template&id=4a59602d"
import script from "./CopyPaste.vue?vue&type=script&lang=ts"
export * from "./CopyPaste.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports